import axios from "axios";
import urls from "../../app-js/urls.js";
import * as Sentry from "@sentry/vue";

export default {
  namespaced: true,

  state: () => ({
    access_token: null,
    profile: null
  }),

  getters: {
    getUserEmail: state => {
      if (state.profile && state.profile.email) {
        return state.profile.email;
      } else {
        return null;
      }
    },

    getUserMobile: state => {
      if (state.profile && state.profile.mobile) {
        return state.profile.mobile;
      } else {
        return null;
      }
    }
  },

  actions: {
    async setAccessToken({ commit }, token) {
      if (token) {
        if (process.client) {
          const Cookies = require("js-cookie");
          Cookies.set("token", token, { path: "/" });
        }
        commit("SET_ACCESS_TOKEN", token);
        const response = await this.$axios.get("/user/profile/");
        commit("SET_USER_PROFILE", response.data);
        Sentry.setUser(response.data);
      }
    },

    setUserProfile({ commit }, profile) {
      localStorage.setItem("user_profile", JSON.stringify(profile));
      commit("SET_USER_PROFILE", profile);
    },

    CancelPayment({ state }) {
      const base_url = urls.BASE_URL + urls.CANCEL_STRIP_PAYMENT;
      const transaction_id = localStorage.getItem("transaction_id");
      axios
        .get(
          `${base_url}/?access_token=${state.access_token}&transaction_id=${transaction_id}`
        )
        .then(res => {
          console.log(res.data, "this is the response");
          localStorage.removeItem("transaction_id");
        })
        .catch(err => {
          console.log(err.response.data, "this is error");
          localStorage.removeItem("transaction_id");
        });
    }
  },

  mutations: {
    SET_ACCESS_TOKEN(state, access_token) {
      state.access_token = access_token;
    },

    SET_USER_PROFILE(state, profile) {
      state.profile = profile;
    }
  }
};
